import { createSelector } from 'reselect'
import { selectCurrentCustomer } from './selectCurrentCustomer'

export const selectCurrentCustomerEmail = createSelector(
  selectCurrentCustomer,
  customer => (customer ? customer.email : undefined)
)
